<template>
  <button
      :class="['mc-btn--'+type, 'is-'+size, isActive]"

      :disabled="disabled"
      type="button"
      @click="_onClick">
    <slot></slot>
  </button>
</template>
<script type="text/ecmascript-6">
    import Emitter from '../mixins/emitter'
  import McContainer from './base-container'
  export default {
    name: 'mcBtn',
    mixins: [Emitter],
    components: {
      McContainer
    },
    props: {

      type: {
        type: String,
        enumeration: ['primary', 'ghost', 'link', 'lowkey', 'text', 'select'],
        default: 'primary'    // primary / ghost / link
      },
      size: {
        type: String,
          enumeration: ['block', 'big', 'medium', 'small', 'mini'],
        default: 'medium',    // block / big / medium / small / mini
      },
      disabled: {
        type: [String, Boolean],
        default: false
      }
    },

    data(){
      return{
          isActive: ''
      }
    },
    watch:{

    },
    methods: {
      _onClick() {
        this.$emit('click')
      },
      onBtnDrop(v){
        if(v){
            this.isActive = 'active'
        }else{
            this.isActive =  ''
        }
      }
    },
      created(){
          this.$on('onBtnDrop', this.onBtnDrop);
      }

  }
</script>




// WEBPACK FOOTER //
// src/components/base-btn.vue